import { SB } from '@play-co/replicant';

const tierItemSchema = SB.object({
  // Tier number
  tier: SB.int(),
  // How many this tier we have
  quantity: SB.int(),
  // When user first get it from gacha
  createdAt: SB.int(),
  // When changed quantity
  updatedAt: SB.int(),
  // Is this item new
  isNew: SB.boolean(),
});

export const purchasedItemSchema = SB.object({
  // Purchase timestamp
  purchasedAt: SB.int(),
  // Is this item new
  isNew: SB.boolean(),
  // Tier item: { tier_id: { tier, quantity... }, ... }
  tier: SB.map(tierItemSchema),
});

export const selectedItemSchema = SB.object({
  // Item ID
  id: SB.string(),
  // Room id, in future we could use this id for layout system as well
  room: SB.string(),
  // Equipped slot
  slot: SB.number(),
  // Tier ID, only defined for gacha players.
  tierId: SB.string().optional(),
});

export default {
  decoration: SB.object({
    // Store purchased items map here: { item_ID: { purchasedAt } }
    purchased: SB.map(purchasedItemSchema),
    // Store equipped (not default items) list of items here
    selected: SB.array(selectedItemSchema),
  }),
};

// Export state types, will be used in getters for converting it to more type safe types
export type PurchasedItemState = SB.ExtractType<typeof purchasedItemSchema>;
export type SelectedItemState = SB.ExtractType<typeof selectedItemSchema>;
